import { render, staticRenderFns } from "./processAccidentRiskPop.vue?vue&type=template&id=55886ee5"
import script from "./processAccidentRiskPop.vue?vue&type=script&lang=js"
export * from "./processAccidentRiskPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55886ee5')) {
      api.createRecord('55886ee5', component.options)
    } else {
      api.reload('55886ee5', component.options)
    }
    module.hot.accept("./processAccidentRiskPop.vue?vue&type=template&id=55886ee5", function () {
      api.rerender('55886ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentRiskPop.vue"
export default component.exports